// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber0 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M12.052 6.794c-2.842 0-3.528 2.506-3.528 5.222 0 2.968.756 5.194 3.542 5.194 2.771 0 3.541-2.226 3.541-5.194 0-2.716-.685-5.222-3.555-5.222m.014 1.54c1.413 0 1.707 1.666 1.707 3.682 0 2.17-.35 3.724-1.707 3.724-1.359 0-1.709-1.554-1.709-3.71 0-2.03.28-3.696 1.709-3.696" />
  );
export default SvgIconNumber0;
